import { badge } from '../../components/Badge/tokens/cobalt';
import { link } from '../../components/Link/tokens/cobalt';
import { link as deprecatedLink } from '../../deprecated/Link/tokens/cobalt';
import { ComponentTokens } from './types';

export const components: ComponentTokens = {
  badge,
  link,
  deprecatedLink,
};
